import { furnitureSize, getFurniture, homes } from './content';
import type { PlayerData } from './types';
export function placementIssue(
  p: Pick<PlayerData, 'home' | 'furnitureOwned' | 'decor'>,
  itemId: string,
  x: number,
  z: number,
  rotation: number,
): 'OWNERSHIP' | 'BOUNDS' | 'OVERLAP' | 'SLOTS' | null {
  const item = getFurniture(itemId);
  if (!item || !p.furnitureOwned.includes(itemId)) return 'OWNERSHIP';
  if (
    ![x, z, rotation].every(Number.isFinite) ||
    Math.abs(x) > 3 ||
    Math.abs(z) > 3 ||
    !Number.isInteger(rotation) ||
    rotation < 0 ||
    rotation > 3
  )
    return 'BOUNDS';
  const size = furnitureSize(item.kind, rotation),
    floor = item.kind === 'rug';
  if (Math.abs(x) + size.width / 2 > 3.9 || Math.abs(z) + size.depth / 2 > 3.9) return 'BOUNDS';
  if (
    !floor &&
    x - size.width / 2 < -2.05 &&
    x + size.width / 2 > -3.55 &&
    z - size.depth / 2 < -1.2 &&
    z + size.depth / 2 > -3.4
  )
    return 'OVERLAP';
  if (
    !p.decor.some((d) => d.itemId === itemId) &&
    p.decor.length >= (homes.find((h) => h.id === p.home)?.slots || 8)
  )
    return 'SLOTS';
  if (
    !floor &&
    p.decor.some((d) => {
      const otherItem = getFurniture(d.itemId);
      if (d.itemId === itemId || !otherItem || otherItem.kind === 'rug') return false;
      const other = furnitureSize(otherItem.kind, d.rotation);
      return (
        Math.abs(d.x - x) < (size.width + other.width) / 2 + 0.12 &&
        Math.abs(d.z - z) < (size.depth + other.depth) / 2 + 0.12
      );
    })
  )
    return 'OVERLAP';
  return null;
}
/** Comfort affects free home recovery, never money issuance or paid-work allowance. */
export function homeComfort(p: Pick<PlayerData, 'home' | 'decor'>) {
  const upgrade =
    Math.max(
      0,
      homes.findIndex((h) => h.id === p.home),
    ) * 3;
  const kinds = new Set(p.decor.map((d) => getFurniture(d.itemId)?.kind));
  return {
    rest: upgrade + (kinds.has('sofa') || kinds.has('chair') || kinds.has('bench') ? 5 : 0),
    cook: upgrade + (kinds.has('table') || p.decor.some((d) => d.itemId === 'coffee-cart') ? 5 : 0),
  };
}
